<template>
  <div class="app">
    <div v-if="isAuthenticatingClient">
      <LandingInitialization />
    </div>
    <div v-if="isClientAuthenticationFailed">
      <Error500 />
    </div>
    <router-view v-if="isClientAuthenticated" />
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import LandingInitialization from '@/components/LandingInitialization'
import Error500 from '@/components/Error500'
import rootAccessor from '@/mixins/root-accessor'
import gaLoader from '@/mixins/ga-loader'

export default {
  name: 'DefaultContainer',
  components: {
    LandingInitialization,
    Error500
  },
  mixins: [ rootAccessor, gaLoader ],
  computed: {
    ...mapGetters({
      isClientAuthenticated: 'auth/isClientAuthenticated',
      isAuthenticatingClient: 'auth/isAuthenticatingClient',
      isClientAuthenticationFailed: 'auth/isClientAuthenticationFailed',
      portalConfigurations: 'tenantDesign/config'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  },
  watch: {
    portalGeneralInfo: function () {
      this.initGoogleAnalytics(true)
    }
  },
  created () {
    // Add body class to body element, the styles for body class will be received from background section defined in landing page sections
    this.addBodyClass('body')
    this.addDataAttribute('data-theme', 'light')
  }
}
</script>

<style>
.body {
  padding-top: 0px !important;
}
</style>
